import styled from 'styled-components';
import { GREY_100 } from '../../../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
    align-self: stretch;
    padding: 0.75rem;
    border-radius: 0.5rem;
    background: ${GREY_100};
`;
